import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const StarIcon = createIcon({
	viewBox: '0 0 20 20',
	path: (
		<path d="M 18.044 7.155 L 12.954 6.714 L 10.966 2.035 C 10.608 1.183 9.389 1.183 9.032 2.035 L 7.044 6.724 L 1.966 7.155 C 1.039 7.229 0.661 8.386 1.365 8.996 L 5.226 12.338 L 4.068 17.303 C 3.858 18.206 4.836 18.923 5.635 18.439 L 9.999 15.81 L 14.363 18.448 C 15.162 18.932 16.14 18.218 15.93 17.313 L 14.774 12.338 L 18.633 8.996 C 19.337 8.386 18.968 7.229 18.044 7.155 Z M 9.999 13.844 L 6.045 16.23 L 7.097 11.73 L 3.605 8.701 L 8.212 8.301 L 9.999 4.063 L 11.798 8.312 L 16.403 8.712 L 12.912 11.74 L 13.963 16.241 L 9.999 13.844 Z" />
	),
});
